module.exports = __webpack_public_path__ + "img/IMG-20200910-WA0001.441445f3.jpg";